/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Hub_Operator_TitleInputs */

const en_legal_hub_operator_title = /** @type {(inputs: Legal_Hub_Operator_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who runs Complete Athlete`)
};

const pl_legal_hub_operator_title = /** @type {(inputs: Legal_Hub_Operator_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kto prowadzi Complete Athlete`)
};

/**
* | output |
* | --- |
* | "Who runs Complete Athlete" |
*
* @param {Legal_Hub_Operator_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_hub_operator_title = /** @type {((inputs?: Legal_Hub_Operator_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Hub_Operator_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_hub_operator_title(inputs)
	return en_legal_hub_operator_title(inputs)
});